import { useGetConfig } from "@onefront/forrestjs-react-root";
import { useTargetUrl } from "../../service-axios";
import { LoginImage } from "../../images";
import { TSLogo } from "../../images";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import Stack from "@vapor/react-material/Stack";
import Button from "@vapor/react-material/Button";
import { useTranslation } from "../../service-i18n";
import { useQueryString } from "../../utils/use-query-string";

export const DefaultPublicView = () => {
  const qs = useQueryString();
  const appId = useGetConfig("one.appId", "app3000");
  const targetUrl = useGetConfig("one.login.target.url", "loginApp");
  const targetUrlParams = useGetConfig("one.login.target.params", [
    "mode=redirect"
  ]);
  const { loading, url: loginUrl } = useTargetUrl(targetUrl, [
    ...targetUrlParams,
    `appId=${appId}`
  ]);
  const { t } = useTranslation("react-sdk");

  // Automatic redirect in case of jump between modules
  if (loginUrl && qs.getItem("sub")) {
    window.location.href = loginUrl;
    return null;
  }

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ p: "32px", gap: "32px", flex: "1" }}
    >
      <TSLogo />
      <LoginImage />
      <ExtendedTypography
        variant="display"
        gutterBottom
        component="div"
        color="primary.textTitleColor"
      >
        {t("login_required")}
      </ExtendedTypography>
      <Button
        variant="contained"
        onClick={() => {
          window.location.href = loginUrl;
        }}
        disabled={loading}
      >
        {t("login_here")}
      </Button>
    </Stack>
  );
};
